<div class="dashboard--module-header">
  <h2 class="subheading-sm">Recent payments <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2><div class="ic-beware-wrapper" *ngIf="issues && issues.length > 0"><span class="ic-beware">!</span></div>
</div>
<div class="module--main">
  <div class="block-num text-center" *ngIf="latestPayment">
    <span class="lg">{{latestPayment.amount | currency:'GBP':'symbol':'1.2-2'}}</span>
    <span class="sm">made on {{latestPayment.paymentDate | date:'dd/MM/yyyy'}}<br>via {{latestPayment.paymentMethod}}</span>
  </div>
  <div class="block-num text-center" *ngIf="!latestPayment">
    <span class="lg">N/A</span>
    <span class="sm">no payment data</span>
  </div>
  <div class="block-detail" *ngIf="historyPayments.length > 0">
    <table *ngIf="!isSearching" class="std-table stacked-sm">
      <thead>
      <th>Payment method</th>
      <th>Date</th>
      <th>Amount</th>
      </thead>
      <tbody>
        <tr *ngFor="let historyPayment of historyPayments">
          <td data-label="Payment method">{{historyPayment.paymentMethod}}</td>
          <td data-label="Date">{{historyPayment.paymentDate | date:'dd/MM/yyyy, h:mm a'}}</td>
          <td data-label="Amount">{{historyPayment.value | currency:'GBP':'symbol':'1.2-2'}}</td>
        </tr>
      </tbody>
    </table>
    <app-pagination *ngIf="historyPayments.length > 0" [page]="page" [pages]="historyPaymentsTotalPages" (pageChange)="getPagedPaymentHistory($event)"></app-pagination>
  </div>
</div>
